var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-wide',[_c('sub-navbar',{attrs:{"page":"Customer"}}),(_vm.isSearchActive)?_c('div',[_c('SearchCompanyToGetBalance')],1):_vm._e(),(!_vm.isSearchActive)?_c('div',[_c('CustomerUnpaidInvoices')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }